import { Crisp } from 'crisp-sdk-web';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['unreadCount'];

  static values = {
    unreadCount: Number,
    default: 0,
  };

  connected() {
    this.chat = Crisp.chat;
    this.message = Crisp.message;

    this.unreadCountValue = this.chat.unreadCount();

    this.boundOnMessageComposeReceived = this.onMessageComposeReceived.bind(this);
    this.message.onMessageComposeReceived(this.boundOnMessageComposeReceived);
    
    this.boundOnChatClosed = this.onChatClosed.bind(this);
    this.chat.onChatClosed(this.boundOnChatClosed);
    
    this.boundOnChatOpened = this.onChatOpened.bind(this);
    this.chat.onChatOpened(this.boundOnChatOpened);
  }

  disconnect() {
    this.message.offMessageComposeReceived();

    // Crisp.offChatClosed();
    // Crisp.offChatOpened();
  }

  unreadCountValueChanged() {
    if (this.unreadCountValue > 0) {
      this.unreadCountTarget.textContent = this.unreadCountValue;
      this.unreadCountTarget.classList.remove('hidden');
    } else {
      this.unreadCountTarget.classList.add('hidden');
      this.unreadCountTarget.textContent = '0';
    }
  }

  onMessageComposeReceived() {
    this.unreadCountValue = this.chat.unreadCount();
  }

  onChatClosed() {
    if (this.chat.isVisible()) {
      this.chat.hide();
    }
  }

  onChatOpened() {
    if (!this.chat.isVisible()) {
      this.chat.show();
    }

    const crispEl = document.querySelector('.crisp-client')
    crispEl.id = 'crisp-client';
    crispEl.dataset.turboPermanent = true;
  }

  toggle() {
    if (this.chat.isChatOpened()) {
      this.chat.close();
    } else {
      this.chat.open();
    }
  }
}
